import React from "react";

import { RouteInfoType } from "../../types/types";

import StatisticsPage from "./pages/statistics";


import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faShoppingBag, faChartBar } from '@fortawesome/free-solid-svg-icons'
import OrdersLayout from "./StatsLayout";
import ShowOrderDetailsForm from "./pages/ordersData/components/ShowDetailsForm";
import OrdersList from "./pages/ordersData/OrdersList";
import { IconProp } from "@fortawesome/fontawesome-svg-core";


const ordersRoutes = [
    {
        id: "orders",
        path: "/stats/",
        header: "Продажи",
        name: "Онлайн-продажи",
        icon: <FontAwesomeIcon icon={faShoppingBag as IconProp} size={"lg"}/>,
        component: OrdersLayout,
        nonCollapsable: true,
        routes: [
            {
                path: "/stats/general",
                name: "Статистика",
                component: StatisticsPage,
                icon: <FontAwesomeIcon icon={faChartBar as IconProp} size={"lg"}/>,
            },
           {
                path: "/stats/list",
                name: "Заказы",
                component: OrdersList,
                icon: <FontAwesomeIcon icon={faShoppingBag as IconProp} size={"lg"}/>,
           },
           {
                path: "/stats/orders/:orderId",
                name: "Детали заказа",
                component: ShowOrderDetailsForm,
                hide: true,
           },
            /*{
                path: "/branches/deliverySettings",
                name: "Доставка",
                component: OrganizationBranchesList,
            },
            {
                path: "/branches/paymentSettings",
                name: "Оплата",
                component: OrganizationBranchesList,
            },
            {
                hide: true,
                path: "/branches/:id/view",
                name: "Список",
                component: OrganizationBranchesList,
            },*/
        ]
    },

] as RouteInfoType[];


export default ordersRoutes;
